import { AUTH_CHANGE, AUTH_LOGIN, DATA_CHANGE } from './types';
import { func, types } from 'utils';

const user = func.mapUser(func.getStorageJson('user') || {}) as types.User;
const token = func.getStorage('token') || '';
const settings = func.getStorageJson('settings') || {};

const initialState = {
    _auth: {
        user,
        token,
        isLoggedIn: user && user.id && token ? true : false,
    },
    _data: {
        phones: {
            NG: { code: '+234', phoneLength: 11 },
            GH: { code: '+233', phoneLength: 10 },
        },
        order: func.getStorageJson('order') || {},
        venue: func.getStorageJson('venue') || {},
        location: func.getStorageJson('location') || { x: 0, y: 0 },
        settings,
        orderStatus: {
            [types.OrderStatus.NEW]: { c: `warning`, t: `New` },
            [types.OrderStatus.READY]: { c: `warning`, t: `Ready` },
            [types.OrderStatus.TIMEOUT]: { c: `danger`, t: `Cancelled` },
            [types.OrderStatus.PAYMENT]: { c: `warning`, t: `Pending` },
            [types.OrderStatus.REJECTED]: { c: `danger`, t: `Cancelled` },
            [types.OrderStatus.ACCEPTED]: { c: `warning`, t: `Preparing` },
            [types.OrderStatus.PREPARING]: { c: `warning`, t: `Preparing` },
            [types.OrderStatus.DELIVERY]: { c: `warning`, t: `In Transit` },
            [types.OrderStatus.ARRIVED]: { c: `warning`, t: `Arrived` },
            [types.OrderStatus.COMPLETED]: { c: `success`, t: `Completed` },
            [types.OrderStatus.CANCELLED]: { c: `danger`, t: `Cancelled` },
            [types.OrderStatus.UNCLAIMED]: { c: `danger`, t: `Unclaimed` },
            [types.OrderStatus.RIDER_PENDING]: { c: 'warning', t: `Looking for rider` },
            [types.OrderStatus.RIDER_UNAVAILABLE]: { c: `warning`, t: `We couldn't find a rider` },
        },
    },
};

const reducer = (state = initialState, { type, payload }: { type: string, payload: any }): any => {

    switch (type) {

        case AUTH_CHANGE:
            return {
                ...state,
                _auth: {
                    ...state._auth,
                    [payload.key]: payload.data,
                },
            };

        case AUTH_LOGIN:
            return {
                ...state,
                _auth: {
                    ...state._auth,
                    ...payload,
                },
            };

        case DATA_CHANGE:
            return {
                ...state,
                _data: {
                    ...state._data,
                    [payload.key]: payload.data,
                },
            };
    }

    return state;

}

export default reducer;